import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@api'

interface Participant {
  accountId: string
  role: 'member' | 'administrator'
}

interface InitiateGroupConversationData {
  participants: Participant[]
  title?: string
  message?: string
}

interface InitiateGroupConversationResponse {
  id: string
}

const initiateGroupConversation = async (
  data: InitiateGroupConversationData
): Promise<InitiateGroupConversationResponse> => {
  const { data: responseData } = await api.post<InitiateGroupConversationResponse>(
    '/conversations/group',
    {
      participants: data.participants,
      ...(data.title && { title: data.title }),
      ...(data.message && { message: data.message }),
    }
  )
  return responseData
}

export const useInitiateGroupConversation = () => {
  const queryClient = useQueryClient()

  return useMutation<InitiateGroupConversationResponse, Error, InitiateGroupConversationData>({
    mutationFn: initiateGroupConversation,
    onSuccess: async (response) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: ['conversations'] }),
        queryClient.invalidateQueries({ queryKey: ['messages', response.id] }),
      ])
    },
  })
}

